import { ATTACHMENT_TYPE } from 'enums';
import { requestAnchorMultipleRequestLoanRequestDownloadAttachment } from 'utils/http/api/anchor/multiple-request-anchor-loans';
import useModal from 'utils/modal/useModal';

export function useAnchorBulkFinancingDetailRequestInformationController(multipleAnchorLoanRequestId: number) {
  const modal = useModal();

  const handleDownloadLoanAgreementClick = async () => {
    try {
      await requestAnchorMultipleRequestLoanRequestDownloadAttachment(
        multipleAnchorLoanRequestId,
        ATTACHMENT_TYPE.LOAN_AGREEMENT,
      );
    } catch (e: any) {
      modal.show(e);
    }
  };

  const handleDownloadLoanRequestAttachmentClick = async () => {
    try {
      await requestAnchorMultipleRequestLoanRequestDownloadAttachment(
        multipleAnchorLoanRequestId,
        ATTACHMENT_TYPE.LOAN_REQUEST,
      );
    } catch (e: any) {
      modal.show(e);
    }
  };

  return {
    handleDownloadLoanAgreementClick,
    handleDownloadLoanRequestAttachmentClick,
  };
}
